<div
  *ngIf="colVm?.columnType === Types.SectionColumnProductInfoType.QuantityAndSize"
  appScaleDownText
  [scaleEnabled]="!(menu | isPrintMenu)"
  [style.color]="
    ignoreUserSetTextColorAndAutoToLightOrDarkTextColor
      ? (section | textColorBasedOnSectionHeaderBackgroundColor)
      : (menu | productMenuBasicMethod: 'getSectionHeaderTextColor' : section)
  "
  [scaleDownLinkedKey]="section?.id + ((section | isInLineMode) ? Types.TextSizeLink.PricePreRollQuantitySize : null)"
  class="section-header-general section-header-quantity">
  {{ menu | productMenuBasicMethod: 'getQuantityAndSizeColumnTitle' : colVm }}
</div>
